"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredRule = void 0;
var validation_rule_1 = require("./validation-rule");
/**
 * A rule that validates that a property has a value
 */
var RequiredRule = /** @class */ (function (_super) {
    __extends(RequiredRule, _super);
    /**
     * Creates a rule that validates that a property has a value.
     * @param rootType The model type the rule is for
     * @param options The options for the rule
     */
    function RequiredRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "Required";
        if (typeof options.message === "function") {
            if (options.when) {
                var messageFn_1 = options.message;
                options.message = function () {
                    if (options.when && !options.when.call(this))
                        return null;
                    return messageFn_1.call(this);
                };
            }
        }
        else {
            // ensure the error message is specified
            options.message = options.message || function () { return rootType.model.getResource("required"); };
            if (options.isValid) {
                if (options.when) {
                    var isValidFn_1 = options.isValid;
                    options.isValid = function () {
                        if (options.when && !options.when.call(this)) {
                            // Valid whether or not there is a value, since requiredness is not in effect
                            return true;
                        }
                        return isValidFn_1.apply(this, arguments);
                    };
                }
            }
            else if (options.message) {
                // create the validation function based on the rule options
                options.isValid = function (prop, val) {
                    if (options.when && !options.when.call(this)) {
                        // Valid whether or not there is a value, since requiredness is not in effect
                        return true;
                    }
                    if (val === undefined || val === null)
                        return false;
                    // Blank string does not pass required check
                    if (typeof val === "string" && val.trim() === "")
                        return false;
                    // Empty array does not pass required check
                    if (Array.isArray(val) && val.length === 0)
                        return false;
                    // False does not pass required check
                    if (typeof val === "boolean" && val === false)
                        return false;
                    return true;
                };
            }
        }
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        return _this;
    }
    // get the string representation of the rule
    RequiredRule.prototype.toString = function () {
        return this.property.containingType.fullName + "." + this.property.name + " is required";
    };
    return RequiredRule;
}(validation_rule_1.ValidationRule));
exports.RequiredRule = RequiredRule;
